"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var utils_1 = require("./table/utils");
var NAME = 'hr';
var Hr = /** @class */ (function (_super) {
    __extends(Hr, _super);
    function Hr() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'hr'; };
        _this.content = '';
        _this.parseDOM = [{ tag: 'hr', getAttrs: function () { return true; } }];
        _this.textMatcher = [{ matcher: [/^---\s$/, /^\*\*\*\s$/] }];
        return _this;
    }
    return Hr;
}(core_utilities_1.Block));
exports.Hr = Hr;
var HrController = /** @class */ (function (_super) {
    __extends(HrController, _super);
    function HrController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'hr',
            tooltip: 'hr',
            handler: function (editor) {
                editor.insertCard('hr', {});
            }
        };
        _this.disable = function (editor) { return Boolean(utils_1.closestTable(editor.view.state.selection.$from)); };
        return _this;
    }
    return HrController;
}(core_utilities_1.SylController));
exports.HrController = HrController;
var HrPlugin = /** @class */ (function (_super) {
    __extends(HrPlugin, _super);
    function HrPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = HrController;
        _this.Schema = Hr;
        return _this;
    }
    return HrPlugin;
}(core_utilities_1.SylPlugin));
exports.HrPlugin = HrPlugin;
//# sourceMappingURL=hr.js.map